module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Bill and I would like to acknowledge the people and organizations that made this book possible. It could not have been written without the service of the World War II crew members of the USS "), _c('i', [_vm._v("Alabama")]), _vm._v(" (BB-60). Over the years, they have volunteered time, knowledge, and memories in order to help make "), _c('i', [_vm._v("Alabama")]), _vm._v("’s history as complete as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We would also like to acknowledge the Battleship Commission, the volunteers and fundraisers who brought "), _c('i', [_vm._v("Alabama")]), _vm._v(" home, and the current staff and volunteers of USS Alabama Battleship Memorial Park. They have all worked over the years to preserve her story.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bill and I would also like to acknowledge Shea McLean, the curator of USS Alabama Battleship Memorial Park, and his staff—Todd Kreamer, Brittany Comiskey, Nora Ives, and Chip Dobson—for their tireless work in telling "), _c('i', [_vm._v("Alabama")]), _vm._v("’s story.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unless otherwise noted, all photographs in this book are courtesy of the USS "), _c('i', [_vm._v("Alabama")]), _vm._v(" and Battleship Memorial Park.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On a personal note, Bill and I would like to thank our wives, Mary Allyson Nagem Whitaker and Cynthia Gregory Tunnell, as well as our families. Thanks for letting us take the time to tell the story of the ship that means so much to both of us. Lastly, Macee Whitaker: thanks for your service to your country and for riding shotgun with me on all of the military history trips we have taken.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 75
// module chunks = 0